__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/4d5ded0/_next/";